define('app/views/templates/helpers/diningStatusToMessage',['Handlebars'], function ( Handlebars ){
    function diningStatusToMessage(status) {
        return app.localization.bookingSummary.diningReservationStatus[status];
    }

    Handlebars.registerHelper( 'diningStatusToMessage', diningStatusToMessage );
    return diningStatusToMessage;
});
